/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareLetterJ = createReactComponent("square-letter-j", "IconSquareLetterJ", [
  [
    "path",
    {
      d: "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M10 8h4v6a2 2 0 1 1 -4 0", key: "svg-1" }]
]);

export { IconSquareLetterJ as default };
//# sourceMappingURL=IconSquareLetterJ.js.map
